import React from "react";
import {Dialog} from "../../components/feedback/Dialog.jsx";
import {Badge} from "../../components/core/Badge.jsx";
import {Icon} from "../../components/core/Icon.jsx";
import {Button} from "../../components/core/Button.jsx";

/* Un flujo por Agente: pasos con lo que lee, lo que hace y con qué. */
export const AGENT_FLOWS={
  "Recepción de casos":{
    icon:"inbox",
    intro:"Del correo de la clínica al caso creado, sin abrir nada a mano.",
    steps:[
      {icon:"mail",label:"Entra el mensaje",copy:"Vigila la bandeja y el WhatsApp. En cuanto llega algo de una clínica conocida, lo coge.",tag:"disparador"},
      {icon:"scan-line",label:"Lee el adjunto",copy:"Saca el STL, comprueba que abre y mira si vienen las dos arcadas o falta el antagonista.",tag:"lectura"},
      {icon:"brain",label:"Identifica el caso",copy:"Qué clínica, qué trabajo, qué material y para cuándo. Si algo no cuadra me lo pregunta a mí, no se lo inventa.",tag:"reglas"},
      {icon:"folder",label:"Crea el caso",copy:"Carpeta con el nombre del paciente, archivos dentro y la clínica ya asignada en el CRM.",tag:"acción"},
      {icon:"check-check",label:"Me avisa",copy:"Un mensaje corto: caso nuevo, clínica, plazo. Yo solo digo adelante.",tag:"salida"}
    ]
  },
  "Laminado":{
    icon:"layers",
    intro:"Prepara el archivo para la Photon Mono M7 con el perfil que toca.",
    steps:[
      {icon:"folder",label:"Ve la carpeta",copy:"Revisa LAMINAR cada pocos minutos. Modelbase y modeldie sin laminar es trabajo pendiente.",tag:"disparador"},
      {icon:"eye",label:"Mira qué es",copy:"Distingue modelo de troquel y cuenta las piezas, que no es el mismo perfil ni el mismo tiempo.",tag:"lectura"},
      {icon:"wrench",label:"Abre el laminador",copy:"Photon Workshop con el perfil de resina correcto, altura de capa y soportes según el tipo de pieza.",tag:"acción"},
      {icon:"printer",label:"Deja en cola",copy:"Manda el archivo a la impresora y lo deja listo para dar al play cuando entro al taller.",tag:"salida"},
      {icon:"database",label:"Lo apunta",copy:"Queda escrito en el caso: perfil usado, hora y tiempo estimado de impresión.",tag:"registro"}
    ]
  },
  "Avisos a clínica":{
    icon:"bell",
    intro:"La clínica sabe dónde está su caso sin que yo escriba un correo.",
    steps:[
      {icon:"layers",label:"El caso cambia de fase",copy:"Diseñado, impreso, en acabado, enviado. El cambio de estado es lo que dispara el aviso.",tag:"disparador"},
      {icon:"brain",label:"Decide si toca escribir",copy:"No avisa de todo: solo de lo que a la clínica le sirve para su agenda.",tag:"reglas"},
      {icon:"message-circle",label:"Redacta el mensaje",copy:"Corto, con el nombre del paciente y el plazo real. Mi tono, no el de una plantilla de empresa.",tag:"acción"},
      {icon:"send",label:"Lo manda",copy:"Correo o WhatsApp, por donde esa clínica hable conmigo habitualmente.",tag:"salida"},
      {icon:"check-check",label:"Cierra el aviso",copy:"Marca el caso como avisado, así nadie recibe dos veces lo mismo.",tag:"registro"}
    ]
  },
  "Albaranes":{
    icon:"file-text",
    intro:"El papeleo del envío, hecho al terminar el caso.",
    steps:[
      {icon:"check-check",label:"Caso terminado",copy:"Cuando marco el trabajo como acabado, empieza el albarán.",tag:"disparador"},
      {icon:"database",label:"Reúne los datos",copy:"Clínica, paciente, unidades, material y fecha. Todo sale del caso, no lo teclea nadie.",tag:"lectura"},
      {icon:"file-text",label:"Rellena el albarán",copy:"Mi formato de siempre, con la numeración correlativa donde debe estar.",tag:"acción"},
      {icon:"folder",label:"Lo archiva",copy:"PDF junto al caso y copia en la carpeta del mes, lista para la gestoría.",tag:"salida"},
      {icon:"printer",label:"Deja la copia",copy:"Una para imprimir y meter en la caja con el trabajo.",tag:"salida"}
    ]
  }
};

function FlowStep({step,active,done,onClick,index}){
  return (
    <button onClick={onClick} aria-current={active?"step":undefined}
      style={{appearance:"none",cursor:"pointer",textAlign:"left",flex:"1 1 96px",minWidth:96,padding:"12px 10px",
        borderRadius:"var(--radius-3)",background:active?"var(--surface-brand)":"var(--surface-card)",
        border:active?"1px solid var(--surface-brand)":"var(--border-hairline)",
        color:active?"#fff":done?"var(--fg-1)":"var(--fg-3)",
        transition:"background-color var(--dur-base) var(--ease-standard),color var(--dur-base) var(--ease-standard),border-color var(--dur-base) var(--ease-standard)"}}>
      <span style={{display:"flex",alignItems:"center",gap:8}}>
        <Icon name={step.icon} size={16} strokeAlign="middle"/>
        <span style={{fontFamily:"var(--font-mono)",fontSize:10,opacity:.7}}>{String(index+1).padStart(2,"0")}</span>
      </span>
      <span style={{display:"block",fontSize:12,lineHeight:1.35,marginTop:8,fontWeight:active?600:500}}>{step.label}</span>
    </button>
  );
}

export function AgentFlowModal({name,onClose}){
  const flow=name?AGENT_FLOWS[name]:null;
  const [i,setI]=React.useState(0);
  React.useEffect(()=>{setI(0)},[name]);
  React.useEffect(()=>{
    if(!flow)return;
    const h=e=>{
      if(e.key==="ArrowRight")setI(v=>Math.min(v+1,flow.steps.length-1));
      if(e.key==="ArrowLeft")setI(v=>Math.max(v-1,0));
      if(e.key==="Escape")onClose();
    };
    window.addEventListener("keydown",h);
    return ()=>window.removeEventListener("keydown",h);
  },[flow,onClose]);
  if(!flow)return null;
  const s=flow.steps[i];
  const last=i===flow.steps.length-1;

  return (
    <Dialog open onClose={onClose} width={720} title={<span style={{display:"flex",alignItems:"center",gap:10}}>
        <span style={{color:"var(--cyan-700)"}}><Icon name={flow.icon} size={20} strokeAlign="middle"/></span>{name}</span>}
      description={flow.intro}
      footer={<>
        <Button variant="ghost" onClick={()=>setI(v=>Math.max(v-1,0))} disabled={i===0}>Anterior</Button>
        {last
          ?<Button variant="accent" onClick={onClose}>Cerrar</Button>
          :<Button variant="accent" onClick={()=>setI(v=>v+1)} iconRight={<Icon name="arrow-right" size={16}/>}>Siguiente paso</Button>}
      </>}>
      <style dangerouslySetInnerHTML={{__html:`
@keyframes dpFlowIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}
.dpFlowRow{display:flex;flex-wrap:wrap;gap:8px}
.dpFlowRow>button{transition:all var(--dur-base) var(--ease-standard)}
@media (prefers-reduced-motion:reduce){.dpFlowDetail{animation:none!important}}
      `}}/>
      <div className="dpFlowRow">
        {flow.steps.map((st,n)=>(
          <FlowStep key={st.label} step={st} index={n} active={n===i} done={n<i} onClick={()=>setI(n)}/>
        ))}
      </div>
      <div className="dpFlowDetail" key={s.label}
        style={{marginTop:18,padding:"18px 18px 20px",borderRadius:"var(--radius-4)",background:"var(--surface-sunken)",
          border:"var(--border-hairline)",animation:"dpFlowIn var(--dur-base) var(--ease-standard) both"}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <Badge tone="info">{s.tag}</Badge>
          <span style={{fontFamily:"var(--font-mono)",fontSize:11,color:"var(--fg-3)"}}>paso {i+1} de {flow.steps.length}</span>
        </div>
        <h4 style={{marginTop:12,display:"flex",alignItems:"center",gap:10}}>
          <span style={{color:"var(--cyan-700)"}}><Icon name={s.icon} size={18} strokeAlign="middle"/></span>{s.label}
        </h4>
        <p style={{fontSize:15,lineHeight:1.6,color:"var(--fg-2)",marginTop:8}}>{s.copy}</p>
      </div>
      <div style={{marginTop:14,height:2,borderRadius:2,background:"var(--line-default)",overflow:"hidden"}}>
        <div style={{height:"100%",width:((i+1)/flow.steps.length*100)+"%",background:"var(--cyan-500)",
          transition:"width var(--dur-base) var(--ease-standard)"}}></div>
      </div>
    </Dialog>
  );
}
